// extracted by mini-css-extract-plugin
export default {"zoomButton":"MapboxCommon_zoomButton__8M+YW"};